<template>
  <Select
    class="company-branches__select"
    :placeholder="placeholder"
    :options="branches"
    :empty-text="emptyStateText"
    :disabled="isDisabled"
    value-key="city"
    label-key="city"
    v-model="selectedBranch"
    @change="handleCompanyBranchSelect"
  >
    <template #option="{ option }">
      <template v-if="option">
        <p class="company-branches-option__branch-type">
          {{ option.branches.map(b => b.type).join(', ') }}
        </p>
        <p class="company-branches-option__branch-city">
          {{ option.city }}
        </p>
      </template>
    </template>
  </Select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Select } from '@/shared/ui/form';

export default {
  components: { Select },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Array,
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Виберіть філію компанії',
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      selectedBranch: null,
    };
  },
  computed: {
    ...mapGetters('companyBranchesModule', ['isLoadingCompanyBranchesData', 'getCompanyBranches']),
    branches() {
      const branchList = this.getCompanyBranches(this.companyId) ?? [];
      const grouped = {};

      branchList.forEach(branch => {
        const city = branch.cityData.name_full_name_ua;
        if (!grouped[city]) {
          grouped[city] = {
            city,
            branches: [],
          };
        }

        grouped[city].branches.push({
          id: branch.id,
          type: branch.type,
          city,
          address: branch.address,
          workingTime: branch.workTime,
          contacts: branch.communications,
        });
      });

      return Object.values(grouped);
    },
    selectedCity() {
      if (!this.value?.length) return null;
      return this.branches.find(group => group.city === this.value[0].city) ?? null;
    },
  },
  watch: {
    selectedCity: {
      immediate: true,
      handler(group) {
        this.selectedBranch = group;
      },
    },
    branches: {
      immediate: true,
      handler(newBranches) {
        if (!this.selectedBranch && newBranches.length > 0) {
          this.selectedBranch = newBranches[0];
          this.handleCompanyBranchSelect(newBranches[0]);
        }
      },
    },
    companyId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchCompanyBranches(newId);
        }
      },
    },
  },
  methods: {
    ...mapActions('companyBranchesModule', ['fetchCompanyBranches']),
    handleCompanyBranchSelect(cityValue) {
      const group = this.branches.find(b => b.city === cityValue);
      if (!group) return;

      this.$emit('input', group.branches);
      this.$emit('change', group.branches);
    },
  },
};
</script>

<style scoped lang="scss">
.company-branches__select {
  width: 100%;
}

.company-branches-option {
  &__branch-type {
    font-weight: bold;
    font-size: 12px;
    margin: 0;
  }

  &__branch-city {
    margin: 0;
  }
}
</style>
